var map = {
	"./call-ended.svg": "e0a7",
	"./lists/no-articles.svg": "673d",
	"./lists/no-chat-messages.svg": "9ecd",
	"./lists/no_guarda_app.svg": "d5bd",
	"./user-waiting.svg": "a959"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e0c";